var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4165 8.50003L8.24642 11.915C8.33934 11.9614 8.3858 11.9847 8.43453 11.9938C8.47769 12.0019 8.52198 12.0019 8.56514 11.9938C8.61388 11.9847 8.66034 11.9614 8.75326 11.915L15.5832 8.50003M1.4165 12.0417L8.24642 15.4566C8.33934 15.5031 8.3858 15.5263 8.43453 15.5355C8.47769 15.5436 8.52198 15.5436 8.56514 15.5355C8.61388 15.5263 8.66034 15.5031 8.75326 15.4566L15.5832 12.0417M1.4165 4.95836L8.24642 1.5434C8.33934 1.49694 8.3858 1.47371 8.43453 1.46457C8.47769 1.45647 8.52198 1.45647 8.56514 1.46457C8.61388 1.47371 8.66034 1.49694 8.75326 1.5434L15.5832 4.95836L8.75326 8.37332C8.66034 8.41978 8.61388 8.44301 8.56514 8.45215C8.52198 8.46025 8.47769 8.46025 8.43453 8.45215C8.3858 8.44301 8.33934 8.41978 8.24642 8.37332L1.4165 4.95836Z",
    stroke: "#2A2A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmount);
export default __webpack_public_path__ + "static/media/amount.fdb350f7333b9568728e5c5f88b362d5.svg";
export { ForwardRef as ReactComponent };